/* eslint-disable no-undef */
(function ($) {
	$(document).ready(function () {
		/**
		 * == Viewfinder instead of 'oo'
		 */

		$("h1:contains('oo')").html(function (_, html) {
			// First, let's wrap the word in it's own tag
			html = html.replace(
				/([a-zA-Z0-9._-]+oo[a-zA-Z0-9._-]+)/g,
				'<span>$1</span>'
			);

			// Then, let's overlay the symbol
			return html.replace(
				/(oo)/g,
				'<span class="oo-svg"><svg width="18" height="10" viewBox="0 0 18 10" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.99914 6.63689C8.38581 6.63689 7.88904 6.7934 7.54369 6.95169C7.3709 7.03089 7.23407 7.11138 7.13666 7.17513C7.08785 7.20708 7.04856 7.23508 7.01922 7.25695C7.00454 7.2679 6.99231 7.27734 6.98259 7.28502C6.97772 7.28886 6.97348 7.29226 6.96987 7.29519C6.96806 7.29666 6.96641 7.29801 6.96492 7.29923L6.96352 7.30039L6.9628 7.30098L6.96183 7.30179L6.96137 7.30217C6.96134 7.30219 6.96132 7.30222 6.962 7.30308C6.47497 7.70698 5.88179 7.96524 5.25187 8.04765C4.62132 8.13014 3.98008 8.03299 3.40333 7.7676C2.82657 7.50221 2.33819 7.07958 1.99544 6.54924C1.65268 6.0189 1.46977 5.40284 1.46812 4.77327C1.46648 4.1437 1.64617 3.5267 1.98615 2.99462C2.32613 2.46253 2.81229 2.03741 3.38765 1.76907C3.96302 1.50073 4.60374 1.4003 5.23471 1.47956C5.86568 1.55882 6.46075 1.81447 6.95016 2.21656L6.95026 2.21644C6.95959 2.22392 6.97109 2.23296 6.98472 2.24335C7.01437 2.26594 7.05426 2.29502 7.1039 2.32833C7.20291 2.39475 7.3424 2.4791 7.51834 2.56231C7.86947 2.72836 8.37677 2.89487 8.9999 2.89487C9.62027 2.89487 10.1228 2.7329 10.4714 2.56975C10.6459 2.4881 10.784 2.40519 10.8821 2.33966C10.9313 2.30681 10.9709 2.27806 11.0004 2.25564C11.0151 2.24442 11.0274 2.23475 11.0372 2.22691C11.042 2.22299 11.0463 2.21952 11.0499 2.21654L11.052 2.21481L11.052 2.21476C11.541 1.81371 12.1353 1.5587 12.7653 1.47956C13.3963 1.40031 14.037 1.50073 14.6123 1.76907C15.1877 2.03741 15.6739 2.46254 16.0139 2.99462C16.3538 3.52671 16.5335 4.1437 16.5319 4.77327C16.5302 5.40284 16.3473 6.01891 16.0046 6.54924C15.6618 7.07958 15.1734 7.50222 14.5967 7.7676C14.0199 8.03299 13.3787 8.13014 12.7481 8.04765C12.1177 7.96518 11.524 7.70653 11.0367 7.30204L11.0366 7.30188L11.0364 7.30179L11.0355 7.30098C11.0348 7.30043 11.0341 7.29985 11.0334 7.29924C11.0326 7.29863 11.0318 7.298 11.031 7.29734C11.0302 7.29666 11.0293 7.29594 11.0284 7.2952C11.0266 7.29373 11.0246 7.29215 11.0225 7.29045C11.0204 7.28875 11.0181 7.28694 11.0157 7.28502C11.006 7.27734 10.9937 7.2679 10.9791 7.25695C10.9497 7.23508 10.9104 7.20708 10.8616 7.17513C10.7642 7.11138 10.6274 7.03089 10.4546 6.95169C10.1092 6.7934 9.61247 6.63689 8.99914 6.63689ZM7.8814 1.09309C7.8814 1.09308 7.88139 1.09308 7.88139 1.09307L7.88098 1.09273L7.8802 1.09207L7.8788 1.09089C7.87794 1.09017 7.87721 1.08957 7.87662 1.08908C7.8755 1.08815 7.87486 1.08763 7.8747 1.0875C7.87499 1.08774 7.87687 1.08923 7.88027 1.09183C7.88817 1.09785 7.9041 1.10963 7.92757 1.12538C7.97477 1.15704 8.05063 1.20349 8.15124 1.25107C8.35322 1.34659 8.64383 1.44166 8.9999 1.44166C9.35873 1.44166 9.64678 1.34822 9.84391 1.25597C9.94232 1.20991 10.0159 1.16511 10.0612 1.13487C10.0837 1.11983 10.0989 1.10867 10.1061 1.10316C10.1078 1.10184 10.1091 1.10086 10.1099 1.10023L10.1102 1.09999L10.1122 1.09834C10.8164 0.519799 11.6726 0.151951 12.5805 0.0379132C13.4883 -0.0761262 14.4102 0.0683728 15.2381 0.454468C16.0659 0.840562 16.7655 1.45225 17.2546 2.21784C17.7438 2.98342 18.0024 3.87118 18 4.77703C17.9976 5.68288 17.7344 6.5693 17.2413 7.33237C16.7481 8.09544 16.0454 8.70354 15.2155 9.08539C14.3857 9.46724 13.463 9.60702 12.5558 9.48834C11.6509 9.36996 10.7987 8.99936 10.0986 8.41983C10.0978 8.41928 10.0969 8.41856 10.0957 8.41767C10.0887 8.41247 10.074 8.40178 10.0519 8.38732C10.0075 8.35824 9.93494 8.31496 9.8377 8.27039C9.64298 8.18114 9.35691 8.0901 8.99914 8.0901C8.64137 8.0901 8.35529 8.18114 8.16058 8.27039C8.06333 8.31496 7.99082 8.35824 7.94639 8.38732C7.92781 8.39949 7.91442 8.40898 7.90648 8.41478L7.90691 8.41529C7.20575 8.99742 6.35147 9.36965 5.44422 9.48833C4.53696 9.60702 3.61433 9.46724 2.78446 9.08539C1.9546 8.70354 1.2519 8.09544 0.758738 7.33237C0.265573 6.5693 0.00238339 5.68288 1.60672e-05 4.77703C-0.00235125 3.87117 0.256206 2.98342 0.745376 2.21784C1.23455 1.45225 1.93406 0.84056 2.76192 0.454465C3.58977 0.068371 4.51166 -0.0761279 5.41953 0.0379108C6.32464 0.151604 7.17842 0.517573 7.8814 1.09309ZM7.8747 1.0875C7.87469 1.08749 7.87468 1.08749 7.87468 1.08748L7.87466 1.08747C7.87466 1.08747 7.87467 1.08748 7.8747 1.0875Z"/></svg><span>$1</span></span>'
			);
		});

		/**
		 * == Splitting Text
		 */

		/**
		 * Start the text split
		 */
		const h1 = document.querySelector('h1');

		const text = SplitType.create(h1, {
			types: 'lines, words',
			lineClass: 'heading__line',
		});

		/**
		 * Mark each line as ready for animation
		 */
		$('.heading__line').each(function () {
			$(this).addClass('before-animate');
		});

		/**
		 * Kick things off line by line
		 */
		$('.heading__line').each(function (i) {
			const $this = $(this);
			setTimeout(function () {
				$this.addClass('animate');
			}, i * 250); // milliseconds
		});

		/**
		 * == When the doc is ready, change H1 to opaque
		 */
		$('.section--type-hero h1').css('opacity', 1);

		/**
		 * Handle window resize
		 */
		const $windowWidth = $(window).width();
		$(window).on('resize', function () {
			// Refresh the line split. Only horizontal resize.
			if ($windowWidth !== $(window).width()) {
				text.split();
			}

			// Prevent the text from animating on the resize.
			$('.heading__line').each(function () {
				$(this).addClass('after-animate');
			});
		});
	});

	/**
	 * == All things map
	 */

	$(window).load(function () {
		// Move pins.
		pins();
	});

	/**
	 * == Background / Text Animation
	 */

	/**
	 * Register an event
	 */
	$(window).on('scroll resize', function () {
		heroParallax();
	});

	function heroParallax() {
		// The scroll depth in pixels
		const scrolled = $(window).scrollTop();
		const heroHeight = window.innerHeight;

		/**
		 * Manipulate the hero container
		 */
		if ($(window).width() >= 745 && scrolled < heroHeight) {
			$('.section--type-hero .container').css({
				transform: 'translateY(' + scrolled * -0.0315 + 'rem)',
			});
			$('.section--type-hero .section__media')
				.css('opacity', 1 - scrolled * (0.7 / heroHeight))
				.css(
					'transform',
					'translate(-50%,-50%) scale(' +
						(1 - scrolled * (0.3 / heroHeight)) +
						')'
				);
		}

		/**
		 * Manipulate each line of text
		 */
		$(
			'.section--type-hero .heading__line, .section--type-hero .paragraph'
		).each(function (i) {
			const index = i + 1;

			if (index - scrolled * (4 / heroHeight) < -1) {
				return;
			}

			if ($(window).width() >= 745) {
				$(this).css({
					opacity: index - scrolled * (4 / heroHeight),
					transform:
						'translateY(' +
						-(index * scrolled * (4 / heroHeight)) +
						'rem) scale(' +
						(1 - scrolled * (0.4 / index / heroHeight)) +
						')',
				});
			} else {
				$(this).css({
					opacity: index - scrolled * (10 / heroHeight),
				});
			}
		});
	}

	function pins() {
		// Define the image source
		const imgSrc = document
			.getElementById('projects-map')
			.getAttribute('data-map');

		const isContained = document
			.getElementById('projects-map')
			.parentNode.classList.contains('container');

		// Create a new image object to get the dimensions
		const img = new Image();
		img.src = imgSrc;

		// Wait for the image to load
		img.onload = function () {
			const w = img.width; // Image width
			const h = img.height; // Image height

			// Define the image bounds
			const imageBounds = [
				[0, 0], // Top-left corner
				[h, w], // Bottom-right corner
			];

			let zoom = -1;

			if (window.innerWidth < 768) {
				if (isContained) {
					zoom = -2;
				} else {
					zoom = -1.5;
				}
			}

			// Initialize the map
			const map = L.map('projects-map', {
				minZoom: zoom, // Minimum zoom level
				maxZoom: zoom, // Maximum zoom level
				maxBoundsViscosity: 1.0,
				crs: L.CRS.Simple,
				attributionControl: false,
				zoomControl: false,
				scrollWheelZoom: false,
			});

			// Add the image overlay
			L.imageOverlay(imgSrc, imageBounds).addTo(map);

			// Set the map bounds to the image bounds
			map.setMaxBounds(imageBounds);

			// Initialize an array to store all the pin coordinates
			const pinLatLngs = [];

			// Add markers (mapPins) to the map
			for (let i = 0; i < projectMapPins.length; i++) {
				const pin = $(projectMapPins[i]).get(0);
				const pinHtml = pin.outerHTML;

				// Read fractional coordinates from data attributes
				const pinXFrac = parseFloat(pin.getAttribute('data-x')); // Fractional X coordinate
				const pinYFrac = 1 - parseFloat(pin.getAttribute('data-y')); // Fractional Y coordinate - leaflet.js has 0,0 bottom left

				// Convert fractional coordinates to pixel coordinates
				const pinX = pinXFrac * w; // Convert fraction to pixel X coordinate
				const pinY = pinYFrac * h; // Convert fraction to pixel Y coordinate

				// Use pixel coordinates for marker placement
				const latLng = [pinY, pinX]; // In L.CRS.Simple, latLng is [Y, X]

				// Store the pin's latLng in the array
				pinLatLngs.push(latLng);

				const pinW = window.innerWidth < 768 ? 32 : 64;
				const pinH = window.innerWidth < 768 ? 32 : 64;

				const icon = L.divIcon({
					html: pinHtml,
					riseOnHover: true,
					iconAnchor: [pinW / 2, pinH], // Set anchor to bottom center
				});

				L.marker(latLng, { icon }).addTo(map);
			}

			// Calculate the bounding box of all pins
			const pinBounds = L.latLngBounds(pinLatLngs);

			// Fit the map to the bounding box of all pins
			map.fitBounds(pinBounds);

			// Function to adjust the map center by a vertical pixel offset
			function adjustMapCenterVertically(offsetY) {
				// Get the current center as a LatLng object
				const currentCenter = map.getCenter();

				// Convert the current center to a pixel point
				const currentCenterPoint =
					map.latLngToContainerPoint(currentCenter);

				// Adjust the pixel point vertically
				const newCenterPoint = L.point(
					currentCenterPoint.x,
					currentCenterPoint.y + offsetY
				);

				// Convert the adjusted pixel point back to a LatLng object
				const newCenter = map.containerPointToLatLng(newCenterPoint);

				// Set the new center
				map.setView(newCenter, map.getZoom());
			}

			adjustMapCenterVertically(75);

			// Handle window resize
			window.addEventListener('resize', function () {
				map.invalidateSize();
			});
		};
	}
})(jQuery);
